export * from "./HoroscopeDetail";
export * from "./HoroscopeList";
export * from "./HoroscopePredictions";